import React, { useState, useEffect, useRef } from "react";
import cn from "classnames";
import { toast } from "react-toastify";
import style from "../common.module.scss";
import { File } from "../../../services";
import { useClickOutside } from "../../../hooks/useClickOutside";
import CloseIconNew from "../../shared/icons/CloseIconNew";
import EyeIcon from "../../shared/icons/EyeIcon";
import DocumentNewIcon from "../../shared/icons/DocumentNewIcon";
import PhotoViewer from "./PhotoViewer";
import Loading from "../../shared/Loading/Loading";
import {t} from "i18next";


const formatDocumentType = (contentType) => {
  const mimeMap = {
    "application/pdf": "pdf",
    "image/png": "png",
    "image/jpeg": "jpg",
    "image/webp": "webp",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
  };

  return mimeMap[contentType] || contentType?.split("/")[1];
};

const DocumentViewer = ({ user, setShowModal, documents }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState({});
  const [uploadedFile, setUploadedFile] = useState(null);
  const [file, setFile] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [imgUrl, setImgUrl] = useState();

  const modalRef = useRef(null);

  useClickOutside(modalRef, () => {
    setShowModal(false);
  });

  const handleClose = () => {
    setIsOpen(false);
  };

  const setLoadingViewer = (docId, isLoading) => {
    setLoadingStates((prev) => ({ ...prev, [docId]: isLoading }));
  };

  const openViewPhoto = (fileType, fileId) => {
    setIsLoading(true);
    setFile(null);
    setLoadingViewer(fileType, true);

    File.getDocument(fileType, fileId)
      .then((response) => {
        console.log("response Bir client ===>", response);
        setIsLoading(false);
        setLoadingViewer(fileType, false);
        const file = new Blob([response.data], {
          type: response.data.type,
        });

        setFile({ file: file, type: response.data.type });

        const fileURL = URL.createObjectURL(file);
        if (response.data.type === "application/pdf") {
          window.open(fileURL, "_blank");
        } else {
          setImgUrl(fileURL);
          setIsOpen(true);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setLoadingViewer(fileType, false);
        console.log("Произошла ошибка, попробуйте позже", error);
        alert("Произошла ошибка, попробуйте позже");
      });
  };

  const onDownload = () => {
    let downloadElement = document.createElement("a");
    downloadElement.href = URL.createObjectURL(file.file);
    downloadElement.download = "driversByOrderCount";
    downloadElement.click();
  };

  return (
    <>
      <div className={style.modalOverlay}>
        <div className={style.modalContent} style={{ gap: "8px" }}>
          <h4>
            {t('registrationSurveyUserSecond.orgType.transporter')}
            <CloseIconNew onClick={() => setShowModal(false)} style={{ cursor: "pointer" }} />
          </h4>
          {documents && documents.filter((doc) => doc?.type === 0 || doc?.type === 2).length > 0 ? (
            <div className={style.documentsList}>
              {documents
                .filter((doc) => doc?.type === 0 || doc?.type === 2)
                .map((doc, index) => (
                  <div key={index} className={style.documentItem}>
                    <div className={style.documentItem_icon}>
                      <DocumentNewIcon />
                    </div>
                    <div className={style.documentItem_content}>
                      <div className={style.documentItem_name}>
                        {doc?.type === 0
                          ? t('tooDocument')
                          : doc?.type === 2
                          ? t('appointmentOrder')
                          : t('doc')}
                        .{formatDocumentType(doc?.contentType)}
                      </div>
                      <div className={style.documentItem_size}>200 kb・{t('uploaded')}</div>
                    </div>

                    {loadingStates[doc?.type] ? (
                      <Loading inBlock marginBottom={0} />
                    ) : (
                      <EyeIcon
                        onClick={() => {
                          openViewPhoto(doc?.type, doc?.userId);
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    )}
                  </div>
                ))}
            </div>
          ) : (
            <span>{t('noPartnerDocs')}</span>
          )}
        </div>
      </div>

      {isOpen && <PhotoViewer imgUrl={imgUrl} onClose={handleClose} onDownload={onDownload} ShowBtnDownload />}
    </>
  );
};

export default DocumentViewer;
